<template>
    <div>
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class="panel  profile-panel profile-contact text-center">
                    <template v-if="hasContactInformation">
                        <edit-button modal-target="editProfile"/>
                        <h3 v-text="$t('wi.contact_information')" class="tw-mb-10"></h3>
                        <div>
                            <p v-text="contactsData.address" v-if="contactsData.address"></p>
                            <p v-if="contactsData.city && contactsData.state">{{ contactsData.city }}, {{
                                contactsData.state}}</p>
                            <p v-if="contactsData.country || contactsData.postal_code">
                                <span v-if="contactsData.country" v-text="contactsData.country"></span>
                                <span v-if="contactsData.postal_code"><span v-if="contactsData.country"> ,</span> {{ contactsData.postal_code }}</span>
                            </p>
                        </div>
                        <div class="text-lowercase">
                            <p v-if="contactsData.phone_mobile">{{ $t('wi.mobile') }} <span
                                    v-text="contactsData.phone_mobile"></span></p>
                            <p v-if="contactsData.phone_home">{{ $t('wi.home') }} <span
                                    v-text="contactsData.phone_home"></span></p>
                        </div>
                        <div class="tw-flex tw-justify-center">
                            <div class="social-buttons mg-top-20 text-left tw-flex tw-flex-col">
                                <social-media-link platform="twitter" v-if="contactsData.twitter" :value="contactsData.twitter"/>
                                <social-media-link platform="facebook" v-if="contactsData.facebook" :value="contactsData.facebook"/>
                                <social-media-link platform="instagram" v-if="contactsData.instagram" :value="contactsData.instagram"/>
                                <div class="social-em mg-bottom-15" v-if="contactsData.email" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                                    <a :href="`mailto:${contactsData.email}`" rel="external">
                                        <span class="fa-layers fa-fw mg-right-10">
                                                <i class="fas fa-circle fa-lg"></i>
                                            <i class="fa-inverse fas fa-envelope" data-fa-transform="right-4"></i>
                                        </span>
                                        <span v-text="contactsData.email"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>
                    <empty-state
                            v-else
                            title="Contact Information"
                            description="Tell people how they can get in touch with you."
                            :button="{caption: 'Add Your Contact Info'}"
                            modalTarget='editProfile'
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import {mapGetters} from 'vuex';
    import EmptyState from './EmptyState';
    import EditButton from './VisualElements/EditButton';
    import SocialMediaLink from './VisualElements/SocialMediaLink';

    export default {
        name: 'Contacts',
        components: {
            EditButton,
            EmptyState,
            SocialMediaLink
        },
        computed: {
            ...mapGetters({
                roles: 'player-profile/roles',
                contactsData: 'player-profile/contacts'
            }),
            hasContactInformation() {
                let status = false;
                [
                    'address',
                    'city',
                    'state',
                    'country',
                    'postal_code',
                    'mobile_phone',
                    'home_phone',
                    'facebook',
                    'twitter',
                    'instagram'
                ].forEach(field => {
                    if (this.contactsData.hasOwnProperty(field) && this.contactsData[field] !== null && this.contactsData[field] !== '') {
                        status = true;
                    }
                });

                return status;
            }
        }
    }
</script>
